import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  public googleMapsKey = 'AIzaSyCanSKDaYGFrRCU3Yvm7e0NPRR8eRmfHTA';
  public googleMapsUrl;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.googleMapsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.google.com/maps/embed/v1/place?key=${this.googleMapsKey}&q=CoolTech+Refrigeration+Ice&zoom=7`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/contact/contact.component.ts